@solidale.controller 'PwdResetCtrl', ['$rootScope', '$scope', '$state', '$stateParams', '$q', 'Auth', '$timeout', ($rootScope, $scope, $state, $stateParams, $q, Auth, $timeout) ->

	# Page ini
	$pageIni = ()->
		$scope.reset = 
			token: $stateParams.token
			email: $stateParams.email
			password: ''
			password_confirmation: ''


	# Error Ini	
	$errorIni = ()->
		$scope.error = 
			input: false
			pwdlength: false
			pwdnomatch: false
			reset: false

	$pageIni()		
	$errorIni()

	$checkInput = ()->
		defer = $q.defer()

		$errorIni()
		$isError = false

		if angular.equals($scope.reset.password, $scope.reset.password_confirmation)

			angular.forEach $scope.reset, (v, k) ->
				if v.length < 1
					$scope.error.input = true
					$isError = true
				
				if angular.equals(k, 'password') && v.length < 8
					$scope.error.pwdlength = true
					$isError = true

		else
			$scope.error.pwdnomatch = true	
			$isError = true		

		
		defer.resolve $isError
		defer.promise

	
	# Send 
	# =========================	
	$resetError = ()->
		$scope.error.reset = true

		$timeout ()->
			$rootScope.closeLoading()
		, 1000

	$resetSuccess = ()->
		$scope.error.reset = false

		$timeout ()->
			$rootScope.closeLoading()
			$rootScope.completePrompt('パスワードは既に更新しました')
		, 1000

		$timeout ()->
			window.location = '/'
		, 5000

	$scope.resetClick = ()->
		$checkInput().then (isError)->
			if !isError
				$rootScope.openLoading()

				Auth.reset($scope.reset, $resetSuccess, $resetError)


]